import script from "./MainwavePickerFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./MainwavePickerFilter.vue?vue&type=script&setup=true&lang=js"

import "./MainwavePickerFilter.vue?vue&type=style&index=0&id=5881abfe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5881abfe"]])

export default __exports__